"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZMarginConfiguration = exports.ZSingleSlotConfig = exports.ZQuadrantConfig = exports.ZExclusionConfig = exports.ZPseudoStyle = exports.ZPseudoContent = exports.ZMarginSlotPosition = exports.ZMarginVariablesEnum = void 0;
const zod_1 = require("zod");
const jss_1 = __importDefault(require("jss"));
exports.ZMarginVariablesEnum = zod_1.z.enum([
    'actName',
    'actPage',
    'docPage',
    'docPageCount',
    'docTitle',
    'sleneName',
    'slenePage',
    'sleneNumber',
    'timestamp',
]);
exports.ZMarginSlotPosition = zod_1.z.enum([
    'topLeft',
    'topCenter',
    'topRight',
    'bottomLeft',
    'bottomCenter',
    'bottomRight',
]);
// for the content applied to ::before and ::after pseudo elements, we can
// configure an array of string literals and variables and sling them together.
const ZPseudoMarginVarContent = zod_1.z.array(exports.ZMarginVariablesEnum).max(1).min(1);
exports.ZPseudoContent = zod_1.z.array(zod_1.z.string().or(ZPseudoMarginVarContent));
// a pseudostyle is a style that can be applied to a
// ::before or ::after pseudo element that does NOT include
// the content property (we supply those separately)
// We build our own custom zod schema type for it using
// an async validator
exports.ZPseudoStyle = zod_1.z
    .record(zod_1.z.string())
    .refine((value) => !Object.keys(value).includes('content'), {
    message: 'Cannot supply "content" to pseudostyle',
})
    .refine(
// try to create a stylesheet that styles a pseudoelement-- if it
// throws, don't pass validation
(value) => {
    try {
        jss_1.default.createStyleSheet({ 'div::after': value });
        return true;
    }
    catch (e) {
        return false;
    }
}, { message: 'Invalid style' });
// if we want to exclude something when it's on a page that
// starts the doc, act or scene, we pass that information this way
exports.ZExclusionConfig = zod_1.z.object({
    doc: zod_1.z.array(zod_1.z.number()).optional(),
    slene: zod_1.z.array(zod_1.z.number()).optional(),
    act: zod_1.z.array(zod_1.z.number()).optional(),
});
// each ::before and ::after has content and optional additional styles
exports.ZQuadrantConfig = zod_1.z.object({
    content: exports.ZPseudoContent,
    styles: exports.ZPseudoStyle.or(zod_1.z.literal(null)),
    exclusions: exports.ZExclusionConfig.or(zod_1.z.literal(null)),
});
// Each slot has two rows (each is a <div>). Each row has a ::before and an ::after.
// that can be used. Each row is configured as an array of two nullable elements
// and the whole slot config has 1 or 2 rows
exports.ZSingleSlotConfig = zod_1.z
    .array(zod_1.z.array(exports.ZQuadrantConfig.or(zod_1.z.literal(null))).length(2))
    .length(2);
exports.ZMarginConfiguration = zod_1.z.object({
    topLeft: exports.ZSingleSlotConfig.optional(),
    topCenter: exports.ZSingleSlotConfig.optional(),
    topRight: exports.ZSingleSlotConfig.optional(),
    bottomLeft: exports.ZSingleSlotConfig.optional(),
    bottomCenter: exports.ZSingleSlotConfig.optional(),
    bottomRight: exports.ZSingleSlotConfig.optional(),
});
